import { MealCreditPayload } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { addMealCreditApi } from 'src/components/oneCorp/features/MealCredit/components/Form/hooks/addMealCreditApi';
import { SdkErrorResponse } from 'src/utilities/notifications';
import { IErrorResponse } from 'src/utilities/shared-types';

export interface UseAddMealCredit {
  addMealCredit: (mealCreditPayload: MealCreditPayload) => Promise<void>;
}

export interface UseAddMealCreditProps {
  corpId: string;
  onSuccess?: ({ id }: { id: string }) => Promise<void>;
  onError?: (error: IErrorResponse | SdkErrorResponse) => Promise<void>;
}

export const useAddMealCredit = ({
  corpId,
  onSuccess,
  onError,
}: UseAddMealCreditProps): UseAddMealCredit => {
  async function addMealCredit(
    mealCreditPayload: MealCreditPayload
  ): Promise<void> {
    try {
      const response = await addMealCreditApi({
        corpId,
        mealCreditPayload,
      });
      await onSuccess?.(response);
    } catch (error) {
      await onError?.(error);
    }
  }

  return { addMealCredit };
};
